module.exports = "<svg width=\"407\" height=\"62\" viewBox=\"0 0 407 62\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.182562 3.77775C172.851 -4.37962 405.409 58.7234 405.409 58.7234\" stroke=\"#DC0000\" stroke-width=\"5\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/splashbanner.svg
// module id = 448
// module chunks = 0